export default "__VITE_ASSET__hCdnLQ0e__"